import { httpRequest } from "../../http";

export class CommandDeleteScheduleEntry {
    async run(entryId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/schedules/entries/${entryId}`
       
        try {
            await httpRequest<any>(url, { method: "DELETE" });
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

}



